import StoryCard from '@/components/feature/StoryCard';
import type { Story } from '@/types/content';

export default function RelatedStories({ stories }: { stories: Story[] }) {
  if (stories.length === 0) return null;

  return (
    <section className="border-t border-background-200 bg-background-100/50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="text-xs font-medium tracking-wide text-accent-700">继续围观</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950">看了这篇，你可能还想看</h2>
          </div>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {stories.slice(0, 3).map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}